<template>
	<div class="unit-model" v-if="urlUnit">
		<div class="maincontent__wrapper">
			<div class="unit-model__carousel">
				<a
					class="unit-model__carousel__nav__prev"
					@click.prevent="moveBy(-1)"
					role="button"
					title="Poprzedni"
				></a>
				<a
					class="unit-model__carousel__nav__next"
					@click.prevent="moveBy(1)"
					role="button"
					title="Następny"
				></a>

				<hooper
					ref="carousel"
					:itemsToShow="1"
					:initialSlide="urlUnitIndex"
					:centerMode="false"
					@slide="onCarouselSlide"
				>
					<slide v-for="u in appData.unitsList" :key="u.name">
						<div class="unit-model__carousel__item">
							<h2 class="unit-model-header">
								<small>Unit stomatologiczny</small><br />
								{{ u.fullName }}
							</h2>
							<div
								class="unit-model__carousel__item__image"
								:style="`background-image: url(${require('@/assets/pictures/' + u.image)})`"
							></div>
						</div>
					</slide>
				</hooper>
				<button class="button" @click.prevent="submit" role="button">Wybierz</button>
			</div>

			<div class="unit-model__description">
				<div class="unit-model__description__main">
					<h4>{{ urlUnit.fullName }}</h4>
					<div v-html="urlUnit.description"></div>
				</div>
				<div class="unit-model__description__summary">
					<h4 v-if="false">Wersja podstawowa posiada:</h4>
					<div v-if="false" v-html="urlUnit.includes"></div>
					<button class="button" @click.prevent="submit" role="button">Wybierz</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';

import {M_SET_MODEL} from '@/store/mutation-types';
import AppDataMixin from '@/mixins/app-data';
import FireLogicOnInitMixin from '@/mixins/fire-logic-on-init';

export default {
	name: 'Model',
	mixins: [AppDataMixin, FireLogicOnInitMixin],
	components: {Hooper, Slide},
	computed: {
		urlUnit() {
			return this.appData.units[R.path(['params', 'name'], this.$route)];
		},
		urlUnitIndex() {
			const name = this.urlUnit.name;
			return this.appData.unitsList.findIndex(e => e.name === name);
		},
	},
	beforeRouteUpdate(to, from, next) {
		if (R.equals(to.params, from.params)) return next(false);

		const index = this.appData.unitsList.findIndex(e => e.name === to.params.name);
		if (index > -1) {
			if (this.$refs.carousel) this.$refs.carousel.slideTo(index);
			next();
		} else {
			next(false);
		}
	},
	methods: {
		submit() {
			if (this.urlUnit.name !== this.unit.name) {
				this.pushUnitChange();
			}
			this.$router.push({name: 'physician-table'}).catch(err => {});
		},
		pushUnitChange() {
			this.$store.commit('unitConfiguration/setUnit', this.urlUnit.name);
			this.$store.commit('setConfiguratorDirty', false);
			this.fireLogicOnInit();
		},
		moveBy(offset) {
			let newIndex = this.urlUnitIndex + offset;
			if (newIndex < 0) newIndex = this.appData.unitsList.length - 1;
			else newIndex = newIndex % this.appData.unitsList.length;

			this.$refs.carousel.slideTo(newIndex);
		},
		setUnit(unitName, onMount = false) {
			if (!this.urlUnit || unitName !== this.urlUnit.name) {
				this.$router
					.replace({
						name: 'model',
						params: {name: unitName},
					})
					.catch(err => {})
					.then(() => {
						if (onMount) {
							return;
						}
						if (this.$store.state.isConfiguratorDirty) {
							if (
								window.confirm(
									'Zmiana modelu unitu spowoduje utratę postępu konfiguratora. Jeśli chcesz dokonać zmiany naciśnij ok. Jeśli chcesz tylko podejrzeć inny model unitu wciśnij anuluj.'
								)
							) {
								this.pushUnitChange();
							}
						} else {
							this.pushUnitChange();
						}
					});
			}
		},
		onCarouselSlide({currentSlide}) {
			this.setUnit(this.appData.unitsList[currentSlide].name);
		},
	},
	mounted() {
		if (!R.has(R.path(['params', 'name'], this.$route), this.appData.units)) {
			this.setUnit(this.$store.state.unitConfiguration.unit, true);
		}
	},
};
</script>
